/**
 * Business Information Card for Accountant Report View
 * Displays business details, location, zone, and event information
 */

import React from 'react';
import { Building2 } from 'lucide-react';

interface BusinessInfoProps {
  businessType: string;
  businessAddress: string;
  zone: string;
  coverageYear?: number;
  eventType?: string;
  eventStartDate?: string;
  eventEndDate?: string;
}

export default function BusinessInfoCard({
  businessType,
  businessAddress,
  zone,
  coverageYear,
  eventType,
  eventStartDate,
  eventEndDate
}: BusinessInfoProps) {
  return (
    <div className="rounded-xl shadow-sm border p-6 mb-6" style={{ backgroundColor: 'var(--color-bg-surface)', borderColor: 'var(--color-border)' }}>
      <h2 className="text-xl font-bold mb-4 flex items-center" style={{ color: 'var(--color-text-primary)' }}>
        <Building2 size={22} className="mr-2" />
        Business Information
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>Business Type</p>
          <p className="text-base font-semibold" style={{ color: 'var(--color-text-primary)' }}>{businessType}</p>
        </div>
        <div>
          <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>Location</p>
          <p className="text-base font-semibold" style={{ color: 'var(--color-text-primary)' }}>{businessAddress}</p>
        </div>
        <div>
          <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>Zone</p>
          <p className="text-base font-semibold" style={{ color: 'var(--color-text-primary)' }}>{zone}</p>
        </div>
        <div>
          <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>Coverage Year</p>
          <p className="text-base font-semibold" style={{ color: 'var(--color-text-primary)' }}>{coverageYear}</p>
        </div>
        {eventType && (
          <>
            <div>
              <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>Event Type</p>
              <p className="text-base font-semibold" style={{ color: 'var(--color-text-primary)' }}>{eventType}</p>
            </div>
            <div>
              <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>Event Period</p>
              <p className="text-base font-semibold" style={{ color: 'var(--color-text-primary)' }}>
                {eventStartDate && new Date(eventStartDate).toLocaleDateString()} - {eventEndDate && new Date(eventEndDate).toLocaleDateString()}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
